document.addEventListener("aa_aiSearchBtnClicked", function(){
    const el = document.getElementById("ai_search_modal");
    window.aiModalSettings.config.locale = myfonts.locale;
    let footerLink = window.aiModalSettings.config.footerLink;
    // Handle both absolute and relative URLs
    if (footerLink.startsWith('http://') || footerLink.startsWith('https://')) {
        footerLink = new URL(footerLink).pathname;
    }
    window.aiModalSettings.config.footerLink = addLocaleToURL(footerLink);
    window.aiModalSettings.config.searchPageUrl = addLocaleToURL(window.aiModalSettings.config.searchPageUrl);
    if(mountAiSearchModal){
        mountAiSearchModal(window.aiModalSettings,el);
    }
});

// add event to mouseenter and mouseleave to the ai_search_dotlottie_wrapper
document.addEventListener("DOMContentLoaded", function(){
    const el = document.querySelector(".ai_search_dotlottie_wrapper");
    if(el){
        el.addEventListener("mouseenter", function(){
            el.classList.add("active");
        });

        el.addEventListener("mouseleave", function(){
            el.classList.remove("active");
        });

        el.addEventListener("click", function(){
            document.dispatchEvent(new CustomEvent("aa_aiSearchBtnClicked"));
        });
    }
});